import createCrudVuexModule from "@/store/crud";

export const receiverGroup = createCrudVuexModule({
  namespaced: true,
  path: "/library/receiver-group",
});

export const workspaceReceiverGroup = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/receiver-group",
});

export const managementReceiverGroup = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/receiver-group",
});
